import { Components, Theme } from '@mui/material';

export const tooltipStyles = ({ theme }: { theme: Theme }) => ({
  ...theme.typography.body2,
  borderRadius: 2,
  backgroundColor: theme.palette.neutral.inverse,
  color: theme.palette.neutral.onInverse,
});

export default {
  defaultProps: {
    arrow: true,
  },
  styleOverrides: {
    tooltip: tooltipStyles,
    arrow: ({ theme }) => ({
      color: theme.palette.neutral.inverse,
    }),
    popper: {
      backgroundColor: 'transparent',
    }
  }
} as Components<Theme>['MuiTooltip'];